import React from 'react';
import { MemberNav } from 'src/remotes/MemberNav';
import { useMemberExperienceAuth } from '@guildeducationinc/auth-frontend-tools';
import { useLocation } from 'react-router-dom';

export const Navigation: React.FC = () => {
	const location = useLocation();
	const { getAccessToken, logout, userFromIdToken: authUser } = useMemberExperienceAuth();

	if (location.pathname.includes('/quiz')) {
		return null;
	}

	return (
		<MemberNav
			analytics={window.analytics}
			getAccessToken={getAccessToken}
			logout={logout}
			productName='catalog'
			skipToContentAnchor='#main'
			user={{
				email: authUser.email,
				employer: authUser.employer,
				employerId: authUser.employer_uuid,
				firstName: authUser.firstName,
				id: authUser.id,
				lastName: authUser.lastName,
			}}
		/>
	);
};
